module.exports = __webpack_public_path__ + "static/media/icon_non.dda81b6a.svg";